module.exports = __webpack_public_path__ + "static/media/memos_note13.d9a71505.jpg";